import moment from "moment";
import Vue from "vue";

Vue.filter("Date", function (value) {
  if (value) {
    return moment(String(value)).format("YYYY/MM/DD");
  }
});
